import {
  getSubSchoolTree,
  getSubGroupList,
  subSchoolSearch,
  getGroupSchoolList,
  getSubSchoolPersonnelList,
} from '../../services/addressList/addressList';

const everNodeChain = {};
function fucTreeRecursion(data, parentArr) {
  const currentData = data;
  const currentParentArr = parentArr;
  const transfromId = `__${currentData.deptId}`;
  let currentArr = [];
  currentArr[0] = `${currentData.deptName}${transfromId}`;
  // eslint-disable-next-line no-unused-expressions
  currentParentArr
    ? (currentArr = currentArr.concat(currentParentArr))
    : (currentArr = currentArr.concat());
  currentData.chain = [].concat(currentArr);
  currentData.chain.reverse();
  everNodeChain[transfromId] = currentData;
  (currentData.subDepts || []).map(item => {
    fucTreeRecursion(item, currentArr);
  });
  return everNodeChain;
}

const initState = () => {
  return {
    spinProps: {
      spinning: true,
      tip: '加载中...',
    },
    nodeChainData: {},
    isRoot: 0,
    currentselectTreeNode: {},
    selectTreeNodeKey: [],
    expandedTreeNodeKeys: [],
    schoolTreeList: [],
    searchValue: '',
    isSearch: false,
    searchResult: null,
    userDetails: {},
    groupSchoolData: [], // 下属学校列表
    subGroupTableData: [], // 下级分组列表
    schoolPersonnelData: [], // 下属学校人员列表
    activeKey: 'subGroup',
    isReloadTable: false, // tree 点击时重新加载右边区域的数据
    selectedSchoolId: '', // 选中的学校id
  };
};

export default {
  namespace: 'subSchoolAddressList',
  state: initState(),
  effects: {
    *fetchSubSchoolTreeList(_, { call, put }) {
      try {
        const data = yield call(getSubSchoolTree);

        const nodeChain = fucTreeRecursion(data);

        yield put({
          type: 'save',
          payload: {
            schoolTreeList: data,
            nodeChainData: nodeChain,
            currentselectTreeNode: data,
            selectTreeNodeKey: [data.deptId],
            expandedTreeNodeKeys: [data.deptId],
            spinProps: {
              spinning: false,
            },
          },
        });
        yield put({
          type: 'fetchDeptList',
          params: { deptId: '', pageIndex: 0, pageSize: 20 },
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 获取当前层级下属分组列表
    *fetchSubGroupList({ params }, { call, put }) {
      try {
        const { groups = [] } = yield call(getSubGroupList, params);

        yield put({
          type: 'save',
          payload: {
            subGroupTableData: groups,
          },
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 获取当前层级下属学校列表
    *fetchGroupSchoolList({ params }, { call, put }) {
      try {
        const { schoolList = [] } = yield call(getGroupSchoolList, params);

        yield put({
          type: 'save',
          payload: {
            groupSchoolData: schoolList,
          },
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 获取下属学校人员信息
    *fetchSchoolPersonnelList({ params }, { call, put }) {
      try {
        const { users = [] } = yield call(getSubSchoolPersonnelList, params);

        yield put({
          type: 'save',
          payload: {
            schoolPersonnelData: users,
          },
        });
      } catch (error) {
        console.log(error);
      }
    },
    *searchFun({ searchValue }, { call, put }) {
      try {
        const { list } = yield call(subSchoolSearch, {
          keyWord: searchValue,
        });
        yield put({
          type: 'save',
          payload: {
            searchResult: list,
            isSearch: false,
          },
        });
      } catch (error) {
        console.log(error);
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return { ...initState() };
    },
  },
};
